var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSleepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#BAC1DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2413 15.9614C33.4937 15.5376 33.1884 15.0004 32.6952 15.0004H28.8389C28.4878 15.0004 28.2032 15.285 28.2032 15.636V16.1814C28.2032 16.5324 28.4878 16.817 28.8389 16.817H30.617L28.5725 20.249C28.3201 20.6727 28.6254 21.21 29.1186 21.21H33.1185C33.4696 21.21 33.7542 20.9254 33.7542 20.5743V20.0289C33.7542 19.6779 33.4696 19.3933 33.1185 19.3933H31.1968L33.2413 15.9614Z",
    fill: "#7E88BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2698 24.1164C13.2698 30.0043 18.085 34.7956 23.9968 34.7956C29.6463 34.7956 34.3423 30.4095 34.7237 24.8077C34.7475 24.5216 34.5807 24.2355 34.2946 24.1164C34.0324 23.9972 33.6987 24.0448 33.4841 24.2594C32.0777 25.6658 30.3614 26.4286 28.6451 26.4286C24.8311 26.4286 21.756 23.3297 21.756 19.5395C21.756 17.7994 22.5188 16.0831 23.9253 14.6767C24.1398 14.4621 24.1875 14.1522 24.0683 13.89C23.9491 13.6278 23.663 13.4609 23.377 13.4609C17.7036 13.7708 13.2698 18.4668 13.2698 24.1164Z",
    fill: "#434C78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSleepIcon);
export default __webpack_public_path__ + "static/media/card-sleep-icon.fd8176c76f4211ce73375a38d84e8634.svg";
export { ForwardRef as ReactComponent };